import styled from 'styled-components'

export const NothingQueuedMessage = styled.div`
    font-size: 18px;
    color: ${p => p.theme.textColor};
    opacity: 0.6;
    margin: 12px auto 16px auto;
    padding-bottom: 26px;
    border-bottom: 2px solid ${p => p.theme.nowPlayingBgColor};
    text-align: center;
`
